import Badge from '@/modules/badge/models/Badge'
export default {
  namespaced: true,
  actions: {
    async getBadges({ _dispatch }) {
      try {
        const badges = await this._vm.axios.get('api/custom-classes/badges')
        Badge.insert({ data: badges }, { root: true })
      } catch (error) {
        throw error
      }
    },
    async getStudentBadges({ _dispatch }, type) {
      try {
        const badges = await this._vm.axios.get(`api/${type}s/badges`)
        return badges
      } catch (error) {
        throw error
      }
    }
  }
}
